import * as React from 'react';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';
import { RouteComponentProps } from 'react-router-dom';
import { paths } from '../routes';

const PayoutByIdIframe: React.FC<RouteComponentProps<{ id: string }>> = ({ match }) => {
  React.useEffect(() => {
    window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
      props: {
        crumbs: [
          {
            text: 'Reports',
            name: 'reports',
            type: 'ui_tab',
          },
          {
            text: 'Payouts',
            page: paths.payouts,
          },
          {
            text: match.params.id,
          },
        ],
      },
    });
  });

  return (
    <>
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `.react-page { height: 100% }`,
        }}
      />
      <iframe
        title="Track your payouts by statement."
        src={`/webapps_redirect.php?app=retail-reports&next=${encodeURIComponent(
          `/payments/payouts/${match.params.id}${window.location.search}`
        )}`}
        style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
      />
    </>
  );
};

export default withLocalizeAwareIframe(
  withRouteAwareIframe(withValidSessionIframe(PayoutByIdIframe))
);
